import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/game/qsdj3',
    name: 'qsdj3',
    redirect: 'guide',
    children: [
      {
        path: 'guide',
        name: 'qsdj3_guide',
        component: () => import('@/views/games/qsdj/guide.vue')
      },
      {
        path: 'gifts',
        redirect: '/mini/game/qsdj3/gifts'
      }
    ]
  },
  {
    path: '/game/xkm4/guide',
    name: 'xkm4_guide',
    component: () => import('@/views/games/xkm4/guide.vue'),
    meta: {
      userSource: 'a5Guide'
    }
  },
  {
    path: '/game/xkm4/gifts',
    name: 'xkm4_ggifts',
    component: () => import('@/views/games/xkm4/gifts.vue'),
    meta: {
      title: '见面礼',
      keepAlive: true,
      pageInfo: {
        PageID: 10304,
        PageName: '见面礼页'
      }
    }
  },
  {
    path: '/game/xkm4/gift_dialog',
    name: 'xkm4_gift_dialog',
    component: () => import('@/views/games/xkm4/giftsDialog.vue')
  },
  {
    path: '/game/xkm4/receiveGifts',
    name: 'xkm4_receive_gifts',
    component: () => import('@/views/games/xkm4/receiveGiftsDays.vue')
  },
  {
    path: '/game/xkm4/bind/:zone/:sid',
    name: 'xkm_bind',
    component: () => import('@/views/games/xkm4/gameBind.vue'),
    meta: {
      title: '游戏绑定'
    }
  },
  {
    path: '/game/t5/gifts',
    name: 't5_gifts',
    component: () => import('@/views/games/t5/gifts.vue'),
    meta: {
      title: '见面礼'
    }
  },
  {
    path: '/game/t5/receiveGifts',
    name: 't5_receive_gifts',
    component: () => import('@/views/games/t5/receiveGiftsDays.vue'),
    meta: {
      title: '天天领福利'
    }
  },
  {
    path: '/game/t5/bind/:sid?',
    name: 't5_bind',
    component: () => import('@/views/games/t5/gameBind.vue'),
    meta: {
      title: '战地服绑定'
    }
  },
  {
    path: '/game/c6/receiveGifts',
    name: 'c6_receive_gifts',
    component: () => import('@/views/games/c6/receiveGifsDay.vue'),
    meta: {
      title: '天天领福利'
    }
  },
  {
    path: '/game/c6/gifts',
    name: 'c6_gifts',
    component: () => import('@/views/games/c6/gifts.vue'),
    meta: {
      title: '见面礼'
    }
  },
  {
    path: '/game/t5/newBindWays/:way?',
    name: 't5_newBindWays',
    component: () => import('@/views/games/t5/gameNewBindWays.vue'),
    meta: {
      title: '游戏绑定'
    }
  },
  // {
  // 	path: '/game/c6/recharge/:sid',
  // 	name: 'c6_recharge',
  // 	component: () => import('@/views/games/c6/recharge/index.vue'),
  // 	meta: {
  // 		title: '充值中心',
  // 	},
  // },
  {
    path: '/game-recharge/:sid',
    name: 'game_recharge',
    component: () => import('@/views/games/t5/recharge/index.vue'),
    meta: {
      title: '充值中心'
    }
  },
  // {
  // 	path: '/game/xkm4/recharge/:sid',
  // 	name: 'xkm_recharge',
  // 	component: () => import('@/views/games/xkm4/recharge/index.vue'),
  // 	meta: {
  // 		title: '充值中心',
  // 	},
  // },
  {
    path: '/game/x3/gifts',
    name: 'x3_gifts',
    component: () => import('@/views/games/x3/gifts.vue')
  },
  {
    path: '/game/x3/receiveGifts',
    name: 'x3_receiveGifts',
    component: () => import('@/views/games/x3/receiveGiftsDays.vue')
  },
  {
    path: '/game/x3/bind/:zone/:sid',
    name: 'x3_bind',
    component: () => import('@/views/games/x3/gameBind.vue'),
    meta: {
      title: '游戏绑定'
    }
  },
  {
    path: '/game/x5/gifts',
    name: 'x5_gifts',
    component: () => import('@/views/games/x5/gifts.vue')
  },
  {
    path: '/game/x5/receiveGifts',
    name: 'x5_receiveGifts',
    component: () => import('@/views/games/x5/receiveGiftsDays.vue')
  },
  {
    path: '/game/x5/bind/:zone/:sid',
    name: 'x5_bind',
    component: () => import('@/views/games/x5/gameBind.vue'),
    meta: {
      title: '游戏绑定'
    }
  },
  {
    path: '/game/c6/bind/:zone/:sid',
    name: 'c6_bind',
    component: () => import('@/views/games/c6/gameBind.vue'),
    meta: {
      title: '游戏绑定'
    }
  },
  {
    path: '/game/recharge/agreed',
    name: 'recharge_agreed',
    component: () => import('@/views/games/t5/recharge/agreed.vue'),
    meta: {
      title: '梦游社道具直购服务协议'
    }
  },
  {
    path: '/game/real-name-auth',
    name: 'real-name-auth',
    component: () => import('@/views/games/realNameAuth.vue'),
    meta: {
      title: '实名认证'
    }
  },
  {
    path: '/game/bind',
    name: 'game_bind',
    component: () => import('@/views/games/gameBind/index.vue'),
    meta: {
      title: '游戏绑定'
    }
  },
  {
    path: '/game/gameBindMiddlePage',
    name: 'gameBindMiddlePage',
    component: () => import('@/views/games/gameBind/gameBindMiddlePage.vue'),
    meta: {
      title: '账号绑定'
    }
  },
];

export default routes;
